"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../../createSvgIcon"));

var _AngleDown = _interopRequireDefault(require("@rsuite/icon-font/lib/legacy/AngleDown"));

// Generated by script, don't edit it please.
var AngleDown = (0, _createSvgIcon["default"])({
  as: _AngleDown["default"],
  ariaLabel: 'angle down',
  category: 'legacy',
  displayName: 'AngleDown'
});
var _default = AngleDown;
exports["default"] = _default;
module.exports = exports.default;